import { useState } from 'react';

export function useModal() {
  const [open, setOpen] = useState(false);

  function onClose() {
    setOpen(false);
  }

  function onOpen() {
    setOpen(true);
  }

  function onOpenChange(isOpen: boolean) {
    setOpen(isOpen);
  }

  return {
    open,
    onClose,
    onOpen,
    onOpenChange,
  };
}
